import React from "react";
import dayjs from "dayjs";

import { toDate } from "pages/Admin/giveawayManagement/giveawayFormUtils";

interface DateTextProps {
  value?: string | number | Date | null;
  /** dayjs format string. Admin screens use DD/MM/YYYY. */
  format?: string;
  /** Shown when the value is missing or unparseable. */
  fallback?: string;
  showIcon?: boolean;
  className?: string;
}

/**
 * Reusable Date Text
 * Calendar icon + formatted date, used inside admin table cells.
 */
const DateText: React.FC<DateTextProps> = ({
  value,
  format = "DD/MM/YYYY",
  fallback = "-",
  showIcon = true,
  className = "",
}) => {
  const parsedDate = toDate(value);
  const parsed = parsedDate ? dayjs(parsedDate) : (value ? dayjs(value) : null);
  const formatted = parsed && parsed.isValid() ? parsed.format(format) : null;

  return (
    <span className={`inline-flex items-center gap-2 whitespace-nowrap ${className}`}>
      {showIcon && formatted && (
        <i className="st-calendar text-lightgray-200 text-sm" aria-hidden="true" />
      )}
      <span>{formatted ?? fallback}</span>
    </span>
  );
};

export default DateText;
